// API Configuration avec gestion automatique de l'environnement
const getBackendUrl = () => {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  try {
    if (envUrl) {
      const envHost = new URL(envUrl).host;
      const currentHost = window.location.host;
      // Utiliser l'URL d'env seulement si elle pointe vers le même host (évite CORS inter-domaine)
      if (envHost === currentHost) {
        return envUrl;
      }
    }
  } catch (e) {
    // ignore parsing errors and fallback to origin
  }
  // Fallback: utiliser le domaine courant
  return window.location.origin;
};

const API_BASE_URL = getBackendUrl();

export default API_BASE_URL;